import moment from 'moment';

moment.relativeTimeThreshold('s', 59);
moment.relativeTimeThreshold('ss', 0);
